var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPxSel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.821,
    height: 11.356,
    viewBox: "0 0 16.821 11.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10119",
    "data-name": "Group 10119",
    transform: "translate(-1385 -576.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    transform: "translate(8960 10087)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -7570.3955078125 -9502.3779296875 C -7570.42578125 -9502.3779296875 -7570.4560546875 -9502.3779296875 -7570.486328125 -9502.37890625 C -7571.45654296875 -9502.4052734375 -7572.2421875 -9502.771484375 -7572.7568359375 -9503.439453125 C -7573.14404296875 -9503.943359375 -7573.3857421875 -9504.6064453125 -7573.46875 -9505.3828125 C -7573.267578125 -9503.9169921875 -7572.34375 -9502.9794921875 -7571.001953125 -9502.9423828125 L -7570.9951171875 -9502.9423828125 L -7570.98828125 -9502.9423828125 L -7570.92138671875 -9502.9423828125 C -7569.2255859375 -9502.9423828125 -7568.466796875 -9504.4814453125 -7568.466796875 -9506.005859375 C -7568.466796875 -9507.73828125 -7569.51904296875 -9508.9951171875 -7570.96923828125 -9508.9951171875 L -7570.98828125 -9508.9951171875 L -7570.99072265625 -9508.9951171875 L -7570.9931640625 -9508.9951171875 C -7572.22802734375 -9508.982421875 -7573.17578125 -9508.0791015625 -7573.4375 -9506.7607421875 C -7573.3212890625 -9507.4453125 -7573.0458984375 -9508.0556640625 -7572.63427734375 -9508.525390625 C -7572.091796875 -9509.1455078125 -7571.33251953125 -9509.4921875 -7570.49658203125 -9509.5009765625 L -7570.46533203125 -9509.5009765625 C -7569.6298828125 -9509.5009765625 -7568.87353515625 -9509.1474609375 -7568.33544921875 -9508.50390625 C -7567.796875 -9507.859375 -7567.5 -9506.9697265625 -7567.5 -9506.0009765625 C -7567.5 -9504.974609375 -7567.75732421875 -9504.056640625 -7568.22412109375 -9503.41796875 C -7568.7294921875 -9502.728515625 -7569.45703125 -9502.3779296875 -7570.38525390625 -9502.3779296875 C -7570.388671875 -9502.3779296875 -7570.39208984375 -9502.3779296875 -7570.3955078125 -9502.3779296875 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -7570.38525390625 -9501.8779296875 C -7570.4228515625 -9501.8779296875 -7570.4609375 -9501.8779296875 -7570.4990234375 -9501.87890625 C -7571.6259765625 -9501.9091796875 -7572.54345703125 -9502.34375 -7573.15283203125 -9503.134765625 C -7573.70751953125 -9503.85546875 -7574.00048828125 -9504.8466796875 -7574.00048828125 -9506.0009765625 C -7574.00048828125 -9508.2978515625 -7572.52783203125 -9509.98046875 -7570.4990234375 -9510.0009765625 L -7570.46533203125 -9510.0009765625 C -7569.478515625 -9510.0009765625 -7568.58642578125 -9509.5830078125 -7567.9521484375 -9508.8251953125 C -7567.33837890625 -9508.08984375 -7567 -9507.0869140625 -7567 -9506.0009765625 C -7567 -9504.8681640625 -7567.29150390625 -9503.8466796875 -7567.8203125 -9503.123046875 C -7568.4169921875 -9502.30859375 -7569.3037109375 -9501.8779296875 -7570.38525390625 -9501.8779296875 Z M -7570.98828125 -9508.4951171875 C -7572.15966796875 -9508.4833984375 -7573.009765625 -9507.4365234375 -7573.009765625 -9506.005859375 C -7573.009765625 -9504.7939453125 -7572.478515625 -9503.4833984375 -7570.98828125 -9503.4423828125 L -7570.92138671875 -9503.4423828125 C -7569.478515625 -9503.4423828125 -7568.966796875 -9504.8232421875 -7568.966796875 -9506.005859375 C -7568.966796875 -9507.4482421875 -7569.80908203125 -9508.4951171875 -7570.96923828125 -9508.4951171875 L -7570.98828125 -9508.4951171875 Z",
    stroke: "none",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17090",
    "data-name": "Rectangle 17090",
    transform: "translate(1385 577)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 11,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 10,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8865",
    "data-name": "Path 8865",
    d: "M8968.76,10094.216l2.895-3.149,2.895-3.15",
    transform: "translate(-7574 -9510)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8866",
    "data-name": "Path 8866",
    d: "M8974.549,10094.216l-2.895-3.149-2.895-3.15",
    transform: "translate(-7574 -9510)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxSel);
export default __webpack_public_path__ + "static/media/px_sel.4448b664.svg";
export { ForwardRef as ReactComponent };